import Card from "@/components/Card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { InterviewRecordUpdate } from "@/schema/console/interview-records/InterviewRecord";
import { format } from "date-fns";
import { Control, useController, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface InterviewRecordProps {
  updated_at?: Date | null;
  updated_by?: string | null;
  isUpdating: boolean;
  updateInterviewRecord: () => void;
}

function InterviewRecord({
  updated_at,
  updated_by,
  isUpdating,
  updateInterviewRecord,
}: InterviewRecordProps) {

  const { t } = useTranslation();

  const { control } = useFormContext<InterviewRecordUpdate>();
  const {
    field: { value: content, onChange: onContentChange },
  } = useController({
    control,
    name: "content",
  });

  return (
    <div className="flex flex-col gap-5">
      <div className="flex justify-between">
        <div className="flex flex-col gap-2">
          <div className="text-cool-gray-700 text-lg font-bold">
            {t("interview-result-record")}
          </div>
          <div className="flex gap-5 text-cool-gray-700">
            <div>
              {t("last-updated:")}{" "}
              {updated_at
                ? format(updated_at, t("date-time-format"))
                : "----/--/-- --:--"}
            </div>
            <div>
              {t("last-updated by:")} {updated_by ?? "--"}
            </div>
          </div>
        </div>
        <Button
          variant="outline"
          isLoading={isUpdating}
          onClick={() => {
            updateInterviewRecord();
          }}
        >
          {t("update-interview-record")}
        </Button>
      </div>
      <Card className="px-5 py-6 gap-5 flex flex-col">
        <div>{t("interview-record")}</div>
        <Textarea
          value={content}
          onChange={(e) => onContentChange(e.target.value)}
          className="h-[500px]"
        />
      </Card>
    </div>
  );
}

export default InterviewRecord;
